import React from "react";
import { Helmet } from "react-helmet-async";

export default function Destek() {
  return (
    <div>
      <Helmet>
        <title>
          Destekten Yoksun Kalma Tazminatı: Trafik Kazası Sonucu Yaşanan
          Kayıplarınızın Tazmini
        </title>
        <meta
          name="description"
          content="Trafik kazası sonrasında sevdiklerinizin desteğini mi kaybettiniz? Destekten yoksun kalma tazminatının ne olduğunu, kimlerin bu haktan yararlanabileceğini ve bu tazminatın ne zaman talep edilebileceğini öğrenin."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <div className="sm:w-full  sm:mx-auto mt-10 ">
        <h1 className="text-center font-extrabold text-red-900 text-3xl">
          Destekten Yoksun Kalma Tazminatı
        </h1>
      </div>
      <div className="sm:mx-96 mx-2 text-gray-700 font-light text-lg">
        <p className="mt-8">
          Trafik kazası sonrası destekten yoksun kalma tazminatı, bir trafik
          kazası sonucunda hayatını kaybeden veya sürekli sakat kalan bir
          kişinin, ailesinin veya bakmakla yükümlü olduğu kişilerin, hayatta
          olan kişiden bekledikleri ekonomik ve manevi desteğin kaybı nedeniyle
          yaşadıkları zararların tazmin edilmesini amaçlayan bir tazminat
          türüdür. Türk hukukunda bu tazminat, trafik kazasında zarar görenin
          veya hayatını kaybeden kişinin yakınlarına tanınan haklardan biridir.
        </p>
        <p className="mt-8">
          Destekten yoksun kalma tazminatı, kazada hayatını kaybeden veya
          sürekli sakat kalan kişinin, gelir kaybı, bakım ve destek
          hizmetlerinin kaybı, sosyal ve duygusal desteklerin kaybı gibi
          faktörler nedeniyle ailesi veya bakmakla yükümlü olduğu kişilerin
          yaşadığı zararları tazmin etmeyi amaçlar. Bu tazminat, zarar görenin
          ailesinin veya bakmakla yükümlü olduğu kişilerin, zarar görenin
          sağladığı destekten mahrum kalmalarının yol açtığı maddi ve manevi
          kayıpları karşılar.
        </p>

        <p className="mt-8">
          Tazminat miktarı, zarar görenin hayatta olması durumunda beklenen
          ekonomik ve manevi destek miktarını yansıtacak şekilde belirlenir. Bu
          miktar, kazada hayatını kaybeden kişinin gelir düzeyi, ekonomik
          katkısı, ailesine veya bakmakla yükümlü olduğu kişilere sağladığı
          destekler ve diğer faktörlere bağlı olarak değerlendirilir.
        </p>

        <p className="mt-8">
          Destekten yoksun kalma tazminatı talebi için zarar görenin, hayatta
          olan kişinin destekten yoksun kalan aile üyelerinin veya bakmakla
          yükümlü olduğu kişilerin zararlarını kanıtlaması gerekmektedir. Bu
          kanıtlar, zarar görenin gelir düzeyi, sağladığı destekler, aile
          ilişkileri ve diğer uygun delillerle desteklenir.
        </p>
        <p className="mt-8">
          Trafik kazası sonrası destekten yoksun kalma tazminatı, zarar görenin
          ailesinin veya bakmakla yükümlü olduğu kişilerin yaşadığı ekonomik ve
          manevi kayıpların telafi edilmesini amaçlar. Bu tazminat, zarar
          görenin hayatını kaybetmesi veya sürekli sakat kalması durumunda,
          ailesinin veya bakmakla yükümlü olduğu kişilerin ekonomik ve duygusal
          ihtiyaçlarının karşılanmasını sağlar. Tazminat miktarı, mahkeme
          tarafından zarar görenin durumuna ve destekten yoksun kalan aile
          üyelerinin veya bakmakla yükümlü olduğu kişilerin ihtiyaçlarına göre
          belirlenir.
        </p>
        <p className="mt-8">
          Özet olarak, trafik kazası sonrası destekten yoksun kalma tazminatı,
          kazada hayatını kaybeden veya sürekli sakat kalan kişinin ailesinin
          veya bakmakla yükümlü olduğu kişilerin yaşadığı ekonomik ve manevi
          kayıpların tazmin edilmesini amaçlar. Bu tazminat, zarar görenin
          sağladığı destekten mahrum kalan aile üyelerinin veya bakmakla yükümlü
          olduğu kişilerin ihtiyaçlarını karşılar. Tazminat miktarı, zarar
          görenin ekonomik katkısı, destekleri ve ailesinin veya bakmakla
          yükümlü olduğu kişilerin ihtiyaçları doğrultusunda belirlenir.
        </p>
      </div>
    </div>
  );
}
